// ============================================================================
// munkalista.js — SZOBA-ÁTFOGÓ MUNKALISTA (2026-10-18, v103): a tag szobáinak státuszos témái egy helyen: státusz, felelős, határidő,
// a lejárt elöl. Csak kliensoldali nézet: a témákat a tag amúgy is olvashatja (a szoba tagjaként), nincs új szerver-művelet.
//
// A tiszta rész (sorok összeállítása, szűrés, rendezés) itt van, hogy tesztelhető legyen; a megjelenítés a munkalistaView-ban.
// ============================================================================

import { temaCim, hataridoLejart } from "./forumData.js";

export const MUNKALISTA_ALLAPOTOK = ["new", "ocr", "translating", "review", "done"];

/** Az alapértelmezett szűrő: minden státusz, a "kész" nélkül, a lejártak nem kiemelt szűrése nélkül. */
export function alapSzuro() {
  return { allapot: "", keszIs: false, csakLejart: false };
}

/**
 * A munkalista sorai.
 * @param {Array<{roomId: string, name?: string, archived?: boolean}>} szobak a tag szobái (csak ezek jelennek meg)
 * @param {Object<string, Array>} temakSzobankent roomId -> a státuszos témák (forumData.temaDokumentumbol alakban)
 * @param {{allapot: string, keszIs: boolean, csakLejart: boolean}} szuro
 * @param {Date} most
 * @returns {Array<{roomId, topicId, cim, workflow, assignee, due, lejart, lastPostAt}>}
 */
export function munkalistaSorok(szobak, temakSzobankent, szuro = alapSzuro(), most = new Date()) {
  const sorok = [];
  const lathato = new Set((szobak || []).filter((r) => r && !r.archived).map((r) => r.roomId));
  for (const [roomId, temak] of Object.entries(temakSzobankent || {})) {
    if (!lathato.has(roomId)) continue; // csak a tag szobái
    for (const tema of Array.isArray(temak) ? temak : []) {
      if (!tema || tema.kind === "history" || tema.kind === "moved") continue;
      const wf = tema.workflow;
      if (!MUNKALISTA_ALLAPOTOK.includes(wf)) continue;
      if (wf === "done" && !szuro.keszIs && szuro.allapot !== "done") continue;
      if (szuro.allapot && wf !== szuro.allapot) continue;
      const lejart = hataridoLejart(tema.workflowDue, wf, most);
      if (szuro.csakLejart && !lejart) continue;
      sorok.push({
        roomId, topicId: tema.topicId, tema, wf, workflow: wf, assignee: tema.workflowAssignee || "", due: tema.workflowDue || "",
        lejart, lastPostAt: typeof tema.lastPostAt === "number" ? tema.lastPostAt : 0,
      });
    }
  }
  // Rendezés: a lejártak elöl (a legrégebbi határidő legelöl), utána a határidősek (korábbi elöl), végül a határidő nélküliek (legújabb mozgás elöl).
  sorok.sort((a, b) => {
    if (a.lejart !== b.lejart) return a.lejart ? -1 : 1;
    const ad = a.due || "9999-99-99";
    const bd = b.due || "9999-99-99";
    if (ad !== bd) return ad < bd ? -1 : 1;
    return b.lastPostAt - a.lastPostAt;
  });
  return sorok;
}

/** A sor megjelenítendő címe a tartalom nyelvén. */
export function sorCim(sor, contentLang) {
  return temaCim(sor.tema, contentLang);
}
